import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import disableScroll from 'disable-scroll';
import './LoadingSpinner.scss';

const LoadingSpinner = ({ show, delay }) => {
  const [showSpinner, setShowSpinner] = useState(show);
  const showRef = useRef(false);

  useEffect(() => {
    let timer;

    if (showRef.current && !show) {
      timer = setTimeout(() => setShowSpinner(false), delay);
      showRef.current = false;
      disableScroll.off();

    } else if (!showRef.current && show) {
      setShowSpinner(true);
      showRef.current = true;
      disableScroll.on();
    }

    return () => {
      clearTimeout(timer);
      disableScroll.off();
    };
  }, [show, delay]);

  return (
    <div className="ph-loading-spinner-container" style={{ display: showSpinner ? 'block' : 'none' }}>
      <div className="ph-loading-spinner-dual-ring" />
    </div>
  );
};

LoadingSpinner.propTypes = {
  delay: PropTypes.number,
  show: PropTypes.bool
};

LoadingSpinner.defaultProps = {
  delay: 2000,
  show: true
};

export default LoadingSpinner;
